/**
 * navigation.adapter — แปลง "route ของแอป" เป็นการเปลี่ยนหน้า
 *
 * ✨ **ไฟล์นี้ agnostic จริง** — ไม่ import router ยี่ห้อไหน และ **ไม่รู้จัก route ของใคร**
 *    ผู้เรียกส่งเข้ามา 2 อย่าง: วิธีเปลี่ยนหน้า (`navigate`) กับวิธีแปลง route เป็น path
 *    (`pathOf`) · ทั้งคู่เป็นความรู้ของแอป/ฟีเจอร์ ไม่ใช่ของท่อ
 *
 * 🔑 generic บน `TRoute` เพราะ **แต่ละ web มี route union ของตัวเอง** —
 *    `member--web` ใช้ `AppRoute` ของ `feature-auth` · `activities-admin--web` จะมีของตัวเอง
 *    ⇒ ผูก type ไว้ที่นี่เมื่อไร lib นี้ก็ใช้ได้แค่เว็บเดียว ซึ่งขัดกับเหตุผลที่มันอยู่ใน `shared/`
 *
 * ⚠️ รับ `navigate` ทาง param **ไม่เรียก `useNavigate()` เอง** — composition root
 *    ไม่ใช่ component จึงเรียก hook ไม่ได้ (ลำดับการประกอบอยู่ที่ `composition/index.ts` ของแอป)
 */
export type Navigator<TRoute> = {
  go(route: TRoute): void;
};

export function createNavigation<TRoute>(
  navigate: (path: string) => void,
  pathOf: (route: TRoute) => string,
): Navigator<TRoute> {
  return {
    go(route) {
      navigate(pathOf(route));
    },
  };
}
